// EstimateContent Component

import BudgetContent from '../../../project/budget/budget_content/budget_content.jsx'

class EstimateContent extends BudgetContent {
  _isTypeEsimate () {
    return true
  }
}

export default EstimateContent
